// extracted by mini-css-extract-plugin
export default {"wrap":"Q-z","heading":"R-z","formError":"S-z"};